import React from 'react';
import { heights, widths, colors } from './../styles/theme.json';

const BottomBorder = () => (
  <div id={'bottom-border'}>
    <div id={'border-inner'}/>
    <style jsx>{`
      #bottom-border {
        margin-top: ${heights.header};
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      #border-inner {
        width: 100%;
        max-width: ${widths.global_max_width};
        border-bottom: 1px solid ${colors.black};
      }
    `}</style>
  </div>
);

export default BottomBorder;



// WEBPACK FOOTER //
// ./src/components/BottomBorder.js